module.exports = __webpack_public_path__ + "img/nokian.dac6e597.svg";